import React from 'react';
import {
  Button,
  FingerprintIcon,
  Tooltip,
  TooltipPlacement,
  TooltipSize,
} from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

interface DownloadActionProps {
  /**
   * Is Nom 151 enabled to download
   */
  isNom151Enabled: boolean;
  /**
   * Is blockchain enbled to download
   */
  isBlockchainEnabled: boolean;
  /**
   * Is blockchain ready to download
   */
  isBlockchainReady: boolean;
  /**
   * Is pdf enabled to download
   */
  isPdfEnabled: boolean;
  /**
   * Handle Nom 151 download
   */
  handleNom151: () => void;
  /**
   * Handle Blockchain download
   */
  handleBlockchain: () => void;
  /**
   * Handle PDF download
   */
  handlePdf: () => void;
  /**
   * Handle Fingerprint donwload.
   */
  handleFingerprint: () => void;
}

export const DownloadActions: React.FC<DownloadActionProps> = ({
  isNom151Enabled,
  isBlockchainEnabled,
  isBlockchainReady,
  isPdfEnabled,
  handleNom151,
  handleBlockchain,
  handlePdf,
  handleFingerprint,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <div className="mb-5 flex w-full flex-wrap justify-center gap-1 gap-y-2 md:justify-center md:gap-3">
      {isNom151Enabled && (
        <Button
          size="xs"
          variant="outline"
          onClick={handleNom151}
          color="#A5A5A5"
        >
          <div className="flex items-center">
            <img
              src="/img/nom151.svg"
              alt="NOM-151"
              title="NOM-151"
              className="h-[18px] w-[18px] md:h-5 md:w-5"
            />
            <span className="ml-1 text-[10px] md:ml-2 md:text-sm">
              <span className="xl:hidden">NOM</span>
              <span className="hidden xl:inline">NOM-151</span>
            </span>
          </div>
        </Button>
      )}
      {isBlockchainEnabled && (
        <>
          {!isBlockchainReady ? (
            <Tooltip
              text={t(translations.COMMON.BLOCKCHAIN_PROCESSING)}
              placement={TooltipPlacement.top}
              size={TooltipSize.sm}
            >
              <div>
                <Button
                  size="xs"
                  variant="outline"
                  onClick={() => {}}
                  color="#A5A5A5"
                >
                  <div className="flex items-center">
                    <img
                      src="/img/blockchain.svg"
                      alt="Bitcoin"
                      title="Bitcoin"
                      className="h-[18px] w-[18px] md:h-5 md:w-5"
                    />
                    <span className="ml-1 text-[10px] md:ml-2 md:text-sm">
                      <span className="xl:hidden">BTC</span>
                      <span className="hidden xl:inline">Bitcoin</span>
                    </span>
                  </div>
                </Button>
              </div>
            </Tooltip>
          ) : (
            <Button
              size="xs"
              variant="outline"
              onClick={handleBlockchain}
              color="#A5A5A5"
            >
              <div className="flex items-center">
                <img
                  src="/img/blockchain.svg"
                  alt="Bitcoin"
                  title="Bitcoin"
                  className="h-[18px] w-[18px] md:h-5 md:w-5"
                />
                <span className="ml-1 text-[10px] md:ml-2 md:text-sm">
                  <span className="xl:hidden">BTC</span>
                  <span className="hidden xl:inline">Bitcoin</span>
                </span>
              </div>
            </Button>
          )}
        </>
      )}
      {isPdfEnabled && (
        <Button
          size="xs"
          variant="outline"
          onClick={() => handlePdf()}
          color="#A5A5A5"
        >
          <div className="flex items-center">
            <img
              src="/img/descargar-pdf.svg"
              alt="PDF"
              title="PDF"
              className="h-[18px] w-[18px] md:h-5 md:w-5"
            />
            <span className="ml-1 text-[10px] md:ml-2 md:text-sm">PDF</span>
          </div>
        </Button>
      )}

      {isPdfEnabled && (
        <Button
          size="xs"
          variant="outline"
          onClick={handleFingerprint}
          color="#A5A5A5"
          leftIcon={<FingerprintIcon height={18} width={18} className="md:h-5 md:w-5" />}
        >
          <span className="text-[10px] md:text-sm">
            <span className="xl:hidden">Audit</span>
            <span className="hidden xl:inline">{t(translations.COMMON.AUDIT)}</span>
          </span>
        </Button>
      )}
      {isPdfEnabled ? children : null}
    </div>
  );
};

export default DownloadActions;
